import { render, staticRenderFns } from "./dashboardAdmin.vue?vue&type=template&id=4d1bd264&scoped=true&"
import script from "./dashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./dashboardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./dashboardAdmin.vue?vue&type=style&index=0&id=4d1bd264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1bd264",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VIcon,VRow,VToolbar})
